import React from 'react';
import { Image, View } from "react-native"
import { Icon } from 'react-native-elements';
import Colors from '../../../constants/Colorsv2';
import { Text, TouchableOpacity } from "../../../globalComponents/NativeOverrides"
import { URLMetadataProps } from "../../../store/types/soc_svc"

type URLPreviewCardProps = {
    url:string,
    width:number,
    view_mode: 'view' | 'edit',
    url_preview:URLMetadataProps,
    hide_image?:boolean,
    onRemoveUrl?: (url:string) => void
}

const URLPreviewCard = ({ url, view_mode, url_preview, width, hide_image, onRemoveUrl }:URLPreviewCardProps) => {
    
    const handleRemoveUrl = (url:string) => {
        if(!onRemoveUrl){ return }
        onRemoveUrl(url)
    }
    
    if(!url){ return <></> }

    return (
        <TouchableOpacity style={{ flex:1, backgroundColor:Colors.shades.shade100 }} native_id='url-preview' onPress={() => window.open(url, '_blank')}>
            {!url_preview || !url_preview?.ogTitle ?
            <Text size={14} color={Colors.brand.electric}>{url}</Text>
            :
            <View>
                {url_preview.ogImage?.url && !hide_image ?
                <Image source={url_preview.ogImage?.url} style={{ width, height:width * 0.5 }} resizeMode='cover' />
                :<></>}
                <View style={{padding:10}}>
                    <Text size={14} color={Colors.brand.midnight} weight='bold'>{url_preview.ogTitle}</Text>
                    <Text size={12} color={Colors.brand.midnight} weight='regular' style={{ marginTop:5 }}>{url_preview.ogDescription}</Text>
                </View>
            </View>
            }
            {view_mode === 'edit' ?
            <TouchableOpacity style={{ position:'absolute', justifyContent:'center', alignItems:'center', borderRadius:100, top:5, right:5, width:20, height:20, backgroundColor:Colors.shades.white }} onPress={() => handleRemoveUrl(url)}>
                <Icon name='x' type='feather' color={Colors.brand.slate} size={16}/>
            </TouchableOpacity>
            :<></>}
        </TouchableOpacity>
    )
}

export default React.memo(URLPreviewCard, (left, right) => {
    if(left.url !== right.url){ return false }
    if(left.width !== right.width){ return false }
    return true
})